import { settingsBaseModel } from './crud';

export * from './types';
export const settingsModelKeys = settingsBaseModel.keys;

export const useSettingsById = settingsBaseModel.fetchById();
export const useSettingsByIds = settingsBaseModel.fetchByIds();
export const useSettingsMany = settingsBaseModel.fetchMany();
export const useSettingsManyInfiniteQuery = settingsBaseModel.fetchPaginated();
export const useSettingsUpdateOne = settingsBaseModel.edit();
export const useSettingsCreateOne = settingsBaseModel.create();
export const useSettingsRemoveOne = settingsBaseModel.delete();
export const useSettingsRemoveByIds = settingsBaseModel.deleteByIds();

export const useSettingsByIdV2 = settingsBaseModel.fetchByIdV2();
export const useSettingsByIdsV2 = settingsBaseModel.fetchByIdsV2();
export const useSettingsManyV2 = settingsBaseModel.fetchManyV2();
export const useSettingsManyInfiniteQueryV2 =
  settingsBaseModel.fetchPaginatedV2();
export const useSettingsUpdateOneV2 = settingsBaseModel.editV2();
export const useSettingsCreateOneV2 = settingsBaseModel.createV2();
export const useSettingsRemoveOneV2 = settingsBaseModel.deleteV2();
export const useSettingsRemoveByIdsV2 = settingsBaseModel.deleteByIdsV2();

export const useSettingsPagination = settingsBaseModel.fetchPaginated();
export const useSettingsPaginationV2 = settingsBaseModel.fetchPaginatedV2();
